import { useState, useEffect } from 'react'
import { HDSpaWrapper, TimerBox, AnimatedElipse } from "./HDSpaStyles";

const HDSpa = ({bgImage}) => {
  const [elipses] = useState(
   [ {
      id: 0,
      elipse: ".",
     },
    {
      id: 1,
      elipse: ".",
     },
    {
      id: 2,
      elipse: ".",
     }]
  );
    const [launchDate, setLaunchDate] = useState(
      new Date("Mar 27, 2023 08:00:00").getTime()
    );
    const counter = setInterval(() => {
          let now = new Date().getTime();
          let difference = launchDate - now;
      if(difference < 1) {
        setLaunchDate(
          new Date(
            `Mar 27, ${parseInt(new Date().getFullYear()) + 1} 08:00:00`
          ).getTime()
        );
      } else{
        setCountdown({
          daysTillLaunch: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hoursTillLaunch: Math.floor(
            (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutesTillLaunch: Math.floor(
            (difference % (1000 * 60 * 60)) / (1000 * 60)
          ),
          secondsTillLaunch: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    }, 1000)
    const [countdown, setCountdown] = useState({
      daysTillLaunch:' ',
      hoursTillLaunch: ' ',
      minutesTillLaunch: ' ',
      secondsTillLaunch: ' ',
    });
    useEffect(() => {
      const timer = setInterval(() => {
        console.log(countdown)
        clearInterval(counter);
      }, 1000)
      return () => {
        clearInterval(timer)
      }
    }, [countdown, counter])
    return (
      <HDSpaWrapper bgImage={bgImage}>
        <div>
          <h1>HDSpa</h1>
          <h2>Coming Soon
          {elipses.map((elipse) =>  
      <AnimatedElipse key={elipse.id}>
        {elipse.elipse}
      </AnimatedElipse>)}</h2>
          <div>
            <p>
              <TimerBox>{countdown.daysTillLaunch}</TimerBox>
              <span>{countdown.daysTillLaunch > 1 ? "days" : "day"}</span>
            </p>
            <p>
              <TimerBox>{countdown.hoursTillLaunch}</TimerBox>
              <span>{countdown.hoursTillLaunch > 1 ? "hours" : "hour"}</span>
            </p>
            <p>
              <TimerBox>{countdown.minutesTillLaunch}</TimerBox>
              <span>
                {countdown.minutesTillLaunch > 1 ? "minutes" : "minute"}
              </span>
            </p>
            <p>
              <TimerBox>{countdown.secondsTillLaunch}</TimerBox>
              <span>
                {countdown.secondsTillLaunch > 1 ? "seconds" : "second"}
              </span>
            </p>
          </div>
        </div>
        <span>To Launch</span>
      </HDSpaWrapper>
    );
}

export default HDSpa;
